$(document).ready(function() {
  var observer = new MutationObserver(function(){
    changePrice();
    const buttons = document.querySelectorAll('.gl-owl--carousel .owl-nav button.owl-prev, .gl-owl--carousel .owl-nav button.owl-next');
    if (buttons.length > 0) 
      buttons.forEach(button => button.style.setProperty('background', 'rgb(15 77 172)', 'important'));
    
    const slimate_blocks = document.querySelectorAll('.slider-mobile-gutter:not(product-info .slider-mobile-gutter)');
    if (slimate_blocks.length > 0)
      $('.slider-mobile-gutter:not(product-info .slider-mobile-gutter) button').css('display', 'none');
    
    const menu = document.querySelector('.ui-menu');
    if (menu) updateFixedPosition();  

    const select = document.querySelector('#globo-dropdown-sort_options');
    if(select){
      select.style.setProperty('border','1px solid white', 'important');
       select.style.setProperty('border-radius','10px');
    }
    
    const links = document.querySelectorAll('.selected-item>a');
    links.forEach(link => {
      link.style.setProperty('background','rgba(var(--color-foreground, #333), .1)', 'important');
      link.style.setProperty('border','1px solid white', 'important');
    });
    
    const titulos_busqueda = document.querySelectorAll('span.hidden-xs');
    titulos_busqueda.forEach(titulos_busqueda =>{
      titulos_busqueda.style.setProperty('font-weight','bold');
    });
    
    const quick_views = document.querySelectorAll('.open-quick-view');
    quick_views.forEach(quick_view => {
      quick_view.style.setProperty('display', 'none', 'important');
    })

    const discount_code = document.querySelector('.cd-discount-container');
    if(discount_code && !discount_code.previousElementSibling){
      const element = '<div class="cd-special-instructions-header cd-special-instructions-header-active" style="cursor: pointer; justify-content: right; padding-top:2%" onclick="changeVisibilityDiscountCode(this)"><div class="special-instructions-label"><p>Añadir Código de descuento</p></div><svg fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="12" height="12"><path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"></path></svg></div>'
      discount_code.insertAdjacentHTML("beforebegin", element);
      discount_code.style.setProperty('display','none');
    }

    if(window.innerWidth < 767){
      const filtersElement = document.querySelector('.spf-has-filter #gf-tree');
      if(filtersElement){     
          filtersElement.style.setProperty('background-color','#0f1f58','important');
          filtersElement.style.setProperty('--gradient-background',' #0f1f58');
          filtersElement.style.setProperty('--color-background',' 15, 31, 88');
          filtersElement.style.setProperty('--color-foreground',' 255, 255, 255');
          filtersElement.style.setProperty('--color-background-contrast',' 19, 39, 110');
          filtersElement.style.setProperty('--color-shadow',' 18, 18, 18');
          filtersElement.style.setProperty('--color-button','255, 255, 255');
          filtersElement.style.setProperty('--color-button-text','15, 31, 88');
          filtersElement.style.setProperty('--color-secondary-button','15, 31, 88');
          filtersElement.style.setProperty('--color-secondary-button-text','255, 255, 255');
          filtersElement.style.setProperty('--color-link','255, 255, 255');
          filtersElement.style.setProperty('--color-badge-foreground','255, 255, 255');
          filtersElement.style.setProperty('--color-badge-background','15, 31, 88');
          filtersElement.style.setProperty('--color-badge-border','255, 255, 255');
          filtersElement.style.setProperty('--payment-terms-background-color','rgb(15 31 88)');
          const filtro = document.querySelector('.gf-filter-contents');
          if(filtro){
            filtro.style.setProperty('margin','0');
            filtro.style.setProperty('border-radius','0');
            filtro.style.setProperty('padding','3%');
            var element =document.querySelector('.gf-block-title .h3');
            if(element) element.style.setProperty('display','none');
          }    
      }
      let bannerImg = document.querySelector(".banner__media img");
      if (bannerImg) {
        let mobileSrc = bannerImg.getAttribute("data-mobile-src");
        let mobileSrcset = bannerImg.getAttribute("data-mobile-srcset");
        let mobileHeight = bannerImg.getAttribute("data-mobile-height");
        if(bannerImg.getAttribute("src") != mobileSrc){
          bannerImg.setAttribute("src", mobileSrc);
          bannerImg.setAttribute("srcset", mobileSrcset);
          bannerImg.setAttribute("height", mobileHeight);
        }
      }

      const filter = document.querySelector('.spf-has-filter #gf-controls-container .gf-refine-toggle-mobile');
      if(filter){
        filter.style.setProperty('border','none','important');
      }
      
      const carousel = document.querySelectorAll('.spf-product__form-btn-addtocart span');
      if(carousel.length>0){
        carousel.forEach(span=>{
          if (!span.innerHTML.startsWith('<svg')) { 
            span.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            span.style.setProperty('display','flex');
            span.parentElement.style.setProperty('width','auto');
            span.parentElement.style.setProperty('border-radius','10px');
            span.parentElement.parentElement.style.setProperty('justify-content','end');  
          }
        });  
      }
      
    }
    
    
    
  });     
  observer.observe(document.body, { childList: true, subtree: true });

  observer = new MutationObserver((mutationsList, observer) => {
    const instrucc_pedido = $('.cd-special-instructions-header').first(); // Obtiene el primer elemento
    if (instrucc_pedido.length > 0 && !instrucc_pedido.hasClass('initialized')) {
      instrucc_pedido.addClass('initialized'); // Evita que se ejecute varias veces
      instrucc_pedido.click();
      instrucc_pedido.addClass('cd-special-instructions-header-active');
      $('.cd-special-instructions-input-wrapper')
        .addClass('cd-special-instructions-input-wrapper-deactive')
        .removeClass('cd-special-instructions-input-wrapper-active');
      
      observer.disconnect(); // Detenemos la observación para que no siga ejecutándose
    }
  });

// Observa cambios en el `body` (ajusta si el elemento aparece en otro contenedor)
observer.observe(document.body, { childList: true, subtree: true });


  const buttons = document.querySelectorAll('.slider-button'); 
  buttons.forEach(button => {
    var observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
          if (mutation.attributeName === 'disabled') {
              if (button.disabled) button.style.setProperty('display','none');
              else button.style.setProperty('display','flex');             
          }
      });
    });

    observer.observe(button, { attributes: true });
  });

  
  if(window.innerWidth > 767){

    $(document).on('mouseenter', '.slider-mobile-gutter:not(product-info .slider-mobile-gutter)', function() {
      $(this).attr('tabindex', '0'); 
      $(this).find('button:not(:disabled)').css('display', 'flex');
    });
    
    $(document).on('mouseleave', '.slider-mobile-gutter:not(product-info .slider-mobile-gutter)', function() {
      $(this).attr('tabindex', '0'); 
      $(this).find('button').css('display', 'none');
    });
  }
  $(document).on('load','.cd-special-instructions-header', function(){
    const instrucc_pedido = $(this);
    if(instrucc_pedido.length >0){  
      closed = instrucc_pedido.hasClass('cd-special-instructions-header-active');
      if(!closed){
        instrucc_pedido.click();
        instrucc_pedido.addClass('cd-special-instructions-header-active');
        $('.cd-special-instructions-input-wrapper').addClass('cd-special-instructions-input-wrapper-deactive').removeClass('cd-special-instructions-input-wrapper-active');
      }
    }
  })
  $(document).on('click', '.spf-product__form button[type="submit"]', function(event) {
    event.stopPropagation();
    event.preventDefault();
    
    const form = event.target.closest('.spf-product__form');
    
    if (form && form.action.endsWith('/cart/add')) {

      const formData = new FormData(form);
      const variantId = form.querySelector('select[name="id"]').value;

      formData.append('id', variantId);
      formData.append('quantity', 1);
  
      fetch('/cart/add.js?opus=true', {
          method: 'POST',
          body: formData
      })
      .then(response => response.json())
      .then(data => {
          console.log('Producto añadido con éxito:', data);
          opusOpen(); // Abre el carrito de la app externa
      })
      .catch(error => console.error('Error al añadir al carrito:', error));
    }
  });
  $(document).on('click','#glFilter-search-popup .gl-d-close-btn', function(){
    const search_modal = document.querySelector('.search-modal');
    search_modal.style.setProperty('display','block');
    const icono = document.querySelector('.header__icon--search svg:not(.header__icon-close)');
    icono.style.setProperty('display','block');
  });
  $(document).on('click','ul[id^="HeaderMenu-MenuList"] details[id^="Details-HeaderSubMenu"] summary[id^="HeaderMenu-"]', function(event){
    const id_submenu = $(event.target).closest('summary[id^="HeaderMenu-"]')[0].id;
    const categoria_menu =id_submenu.replace('HeaderMenu-','Details-HeaderSubMenu-');
    const menu = $('ul[id^="HeaderMenu-MenuList"]:has(details[id="' + categoria_menu + '"])')[0];
    if (!id_submenu) {
      console.warn('No se encontró id_submenu en el elemento clicado');
      return; // evita el error
    }

    //Abre un submenu
    if ($('#' + id_submenu).attr('aria-expanded') === "true") {
      num_elements = $($('#' + id_submenu).next('ul[id^="HeaderMenu-SubMenuList-"]')[0]).find('li').length;
      if(num_elements > 8) menu.style="width:50rem";
      else menu.style="width:30rem";
      const summarys = document.querySelectorAll(`ul[id^="HeaderMenu-MenuList"] details[id^="Details-HeaderSubMenu"]:not(#${CSS.escape(categoria_menu)})`);
      summarys.forEach(summary => {
        $(summary).removeAttr('open').find('summary').attr('aria-expanded', 'false');
      });
    }
    //Cierra un submenu
    else{
      const openMenus = $(menu).find(`details[id^="Details-HeaderSubMenu"]:not(#${CSS.escape(categoria_menu)})[open], summary[aria-expanded="true"]`);
      const hasOpenSubmenu = openMenus.length > 0;

      if (!hasOpenSubmenu) menu.style="width:20rem";
    }
  });

  $(document).on('click','details[id^="Details-HeaderMenu-"] > summary[id^="HeaderMenu-"]', function(event){
    const id_submenu = $(event.target).closest('summary[id^="HeaderMenu-"]')[0].id;
    const categoria_menu =$('#'+id_submenu)[0].parentElement.id;
    const menu = $('details[id="' +categoria_menu+'"] ul[id^="HeaderMenu-MenuList"]')[0];
    if ($('#' + id_submenu).attr('aria-expanded') === "false") {
      menu.style="width:20rem";
    }
    else{
      const menus = document.querySelectorAll('details[id^="Details-HeaderMenu-"] > summary[id^="HeaderMenu-"]');
      menus.forEach(menu=>{
        var elemento = $(menu).next('ul[id^="HeaderMenu-MenuList"]')[0];
        elemento.style="width:20rem";
      })
    }
    const summarys = document.querySelectorAll('ul[id^="HeaderMenu-MenuList"] details[id^="Details-HeaderSubMenu"]');
      summarys.forEach(summary => {
        $(summary).removeAttr('open').find('summary').attr('aria-expanded', 'false');
      });
  });
});

window.addEventListener('scroll', updateFixedPosition);
window.addEventListener('page:load', changePrice);

function updateFixedPosition() {
  const referenceElement = document.querySelector('.search__input');
  const fixedElement = document.querySelector('.ui-menu');

  if (referenceElement && fixedElement) {
      const rect = referenceElement.getBoundingClientRect();
      fixedElement.style.top = `${rect.bottom}px`;
  }
}

function changePrice(){
  document.querySelectorAll('.spf-product-card__price, .spf-product-card__oldprice, .spf-product-card__saleprice, .price-item, .customer td[headers="RowOrder ColumnTotal"], .order td, .cart__items .product-option, .cart__items .price.price--end').forEach(element => {
    let priceText = element.textContent.trim();
    
    if (priceText.startsWith("€")) {
        let newPrice = priceText.replace("EUR","").replace("€", "").trim() + "€";
        element.textContent = newPrice;
    }
  });
}
function updateVisibilityMenu(element){
  const elemento = document.getElementById('gl-d-searchbox-input');
  const search_modal = element.parentElement.querySelector('.search-modal')
  if (isVisible(elemento)) {
        ejecutarAccion(search_modal);
    } else {
        console.log("Esperando a que el elemento sea visible...");
        esperarVisibilidad(elemento, search_modal);
    }
}
function ejecutarAccion(search_modal){
  search_modal.style.setProperty('display','none');
  const icono = document.querySelector('.header__icon--search svg:not(.header__icon-close)');
  icono.style.setProperty('display','none');
}
function isVisible(el) {
  if(el){
    let rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;

  }
  return false;
}
function esperarVisibilidad(el, search_modal) {  
    let observer = new MutationObserver(() => {
        const elemento = document.getElementById('gl-d-searchbox-input');
        if (isVisible(elemento)) {
            observer.disconnect(); // Deja de observar una vez que es visible
            ejecutarAccion(search_modal); // Ejecuta la acción
        }
    });

    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
}
function changeVisibilityDiscountCode(event){
  if(this.event){
    const element = this.event.target.closest('.cd-special-instructions-header');
    const discount_code = document.querySelector('.cd-discount-container');
    if(element.className.indexOf('cd-special-instructions-header-active')!= -1){
      element.className = element.className.replace('cd-special-instructions-header-active','')
      discount_code.style.setProperty('display','flex');
    }
    else{
      element.className = element.className + ' cd-special-instructions-header-active';
      discount_code.style.setProperty('display','none');
    }
  }
}
